package com.milta.feature.route.data.remote.dto

import com.milta.core.network.PagedResult
import kotlinx.serialization.Serializable

/**
 * Mirrors the backend's generic `PagedResult<T>` envelope (MIL-52 — `GET /routes/history`,
 * `GET /routes/{routeId}/proofs`). Kept in this feature's dto package for now (only these two
 * endpoints use it), same precedent as `ApiError` (introduced in `feature.auth.data.remote.dto`
 * but reused by every other feature's API classes) — move to a shared dto package if a third,
 * unrelated feature needs it later.
 */
@Serializable
data class PagedResultDto<T>(
    val items: List<T>,
    val page: Int,
    val pageSize: Int,
    val totalCount: Int,
)

fun <T, R> PagedResultDto<T>.toDomain(mapItem: (T) -> R): PagedResult<R> = PagedResult(
    items = items.map(mapItem),
    page = page,
    pageSize = pageSize,
    totalCount = totalCount,
)
